module.exports = __webpack_public_path__ + "media/img/decorations/banner-content-before-f488f3cf6bcc78ef4919561b6765733b.svg";